module.exports = __webpack_public_path__ + "474f67c5bff2532b8b0c6103366aa43e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/danhmucsanpham.svg
// module id = ./assets/images/danhmucsanpham.svg
// module chunks = 0